import { createPortal } from "react-dom";

interface CreateFolderPortalProps {
  newFolderName: string;
  onChangeName: (v: string) => void;
  onCancel: () => void;
  onCreate: () => void;
}

/**
 * The "New Collection" modal, portaled to document.body. Shared by the
 * Collections and Places tabs; their differing render guards, folder state, and
 * the create handler stay in the orchestrator and are threaded through props.
 */
export function CreateFolderPortal({
  newFolderName,
  onChangeName,
  onCancel,
  onCreate,
}: CreateFolderPortalProps) {
  return createPortal(
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.3)",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        paddingTop: "20vh",
        zIndex: 10000,
      }}
      onClick={onCancel}
    >
      <div
        style={{
          background: "var(--color-surface)",
          borderRadius: 12,
          padding: 20,
          width: 380,
          maxWidth: "90vw",
          boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            fontSize: 15,
            fontWeight: 600,
            marginBottom: 12,
            color: "var(--color-text)",
          }}
        >
          New Collection
        </div>
        <input
          autoFocus
          value={newFolderName}
          onChange={(e) => onChangeName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && newFolderName.trim()) {
              onCreate();
            }
            if (e.key === "Escape") {
              onCancel();
            }
          }}
          placeholder="Collection name..."
          style={{
            width: "100%",
            height: 44,
            padding: "0 12px",
            border: "1px solid var(--color-border)",
            borderRadius: 8,
            fontSize: 14,
            background: "var(--color-surface)",
            color: "var(--color-text)",
            outline: "none",
            boxSizing: "border-box",
          }}
          onFocus={(e) => (e.currentTarget.style.borderColor = "var(--color-brand)")}
          onBlur={(e) =>
            (e.currentTarget.style.borderColor = "var(--color-border)")
          }
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
            marginTop: 12,
          }}
        >
          <button
            onClick={onCancel}
            style={{
              padding: "6px 16px",
              borderRadius: 6,
              border: "1px solid #e5e7eb",
              background: "var(--color-surface)",
              fontSize: 13,
              cursor: "pointer",
              color: "var(--color-text-muted)",
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => {
              if (newFolderName.trim()) {
                onCreate();
              }
            }}
            disabled={!newFolderName.trim()}
            style={{
              padding: "6px 16px",
              borderRadius: 6,
              border: "none",
              background: "var(--color-brand)",
              color: "#fff",
              fontSize: 13,
              cursor: "pointer",
              opacity: newFolderName.trim() ? 1 : 0.5,
            }}
          >
            Create
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
